// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.overlay-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background: rgba(255, 255, 255, 0.9);
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  border-radius: 8px;
}

.flex-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.loader-wrapper {
  display: inline-block;
}

.loader-message {
  font-size: 0.875rem;
  font-weight: 500;
  animation: fadeIn 0.3s ease-in;
}

.loader-sm {
  transform: scale(0.6);
}

.loader-md {
  transform: scale(1);
}

.loader-lg {
  transform: scale(1.5);
}

.theme-primary {
  --loader-color: #0d6efd;
}

.theme-success {
  --loader-color: #198754;
}

.theme-info {
  --loader-color: #0dcaf0;
}

.theme-warning {
  --loader-color: #ffc107;
}

.theme-danger {
  --loader-color: #dc3545;
}

.theme-light {
  --loader-color: #f8f9fa;
}

.theme-dark {
  --loader-color: #212529;
}

.spinner-loader {
  display: inline-block;
  position: relative;
  width: 50px;
  height: 50px;
}

.spinner-loader .spinner-circle {
  position: absolute;
  width: 4px;
  height: 4px;
  border-radius: 50%;
  background: var(--loader-color, #0d6efd);
  animation: spinner-fade 1.2s linear infinite;
}

.spinner-loader .spinner-circle:nth-child(1) {
  top: 0;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: 0s;
}

.spinner-loader .spinner-circle:nth-child(2) {
  top: 8px;
  right: 8px;
  animation-delay: -0.1s;
}

.spinner-loader .spinner-circle:nth-child(3) {
  top: 50%;
  right: 0;
  transform: translateY(-50%);
  animation-delay: -0.2s;
}

.spinner-loader .spinner-circle:nth-child(4) {
  bottom: 8px;
  right: 8px;
  animation-delay: -0.3s;
}

.spinner-loader .spinner-circle:nth-child(5) {
  bottom: 0;
  left: 50%;
  transform: translateX(-50%);
  animation-delay: -0.4s;
}

.spinner-loader .spinner-circle:nth-child(6) {
  bottom: 8px;
  left: 8px;
  animation-delay: -0.5s;
}

.spinner-loader .spinner-circle:nth-child(7) {
  top: 50%;
  left: 0;
  transform: translateY(-50%);
  animation-delay: -0.6s;
}

.spinner-loader .spinner-circle:nth-child(8) {
  top: 8px;
  left: 8px;
  animation-delay: -0.7s;
}

@keyframes spinner-fade {
  0%, 39%, 100% {
    opacity: 0;
    transform: scale(0.3);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}
.dots-loader {
  display: flex;
  gap: 8px;
}

.dot {
  width: 12px;
  height: 12px;
  border-radius: 50%;
  background: var(--loader-color, #0d6efd);
  animation: dot-bounce 1.4s ease-in-out infinite;
}

.dot:nth-child(1) {
  animation-delay: -0.32s;
}

.dot:nth-child(2) {
  animation-delay: -0.16s;
}

.dot:nth-child(3) {
  animation-delay: 0s;
}

.dot:nth-child(4) {
  animation-delay: 0.16s;
}

@keyframes dot-bounce {
  0%, 80%, 100% {
    transform: scale(0);
    opacity: 0.5;
  }
  40% {
    transform: scale(1);
    opacity: 1;
  }
}
.pulse-loader {
  position: relative;
  width: 60px;
  height: 60px;
}

.pulse-ring {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 100%;
  height: 100%;
  border: 3px solid var(--loader-color, #0d6efd);
  border-radius: 50%;
  animation: pulse-ring 1.5s ease-out infinite;
}

.pulse-ring:nth-child(1) {
  animation-delay: 0s;
}

.pulse-ring:nth-child(2) {
  animation-delay: -0.5s;
}

.pulse-ring:nth-child(3) {
  animation-delay: -1s;
}

@keyframes pulse-ring {
  0% {
    transform: translate(-50%, -50%) scale(0.1);
    opacity: 1;
  }
  100% {
    transform: translate(-50%, -50%) scale(1);
    opacity: 0;
  }
}
.bars-loader {
  display: flex;
  gap: 4px;
  align-items: center;
  height: 40px;
}

.bar {
  width: 6px;
  height: 20px;
  background: var(--loader-color, #0d6efd);
  border-radius: 3px;
  animation: bar-wave 1.2s ease-in-out infinite;
}

.bar:nth-child(1) {
  animation-delay: -1.1s;
}

.bar:nth-child(2) {
  animation-delay: -1s;
}

.bar:nth-child(3) {
  animation-delay: -0.9s;
}

.bar:nth-child(4) {
  animation-delay: -0.8s;
}

.bar:nth-child(5) {
  animation-delay: -0.7s;
}

@keyframes bar-wave {
  0%, 100% {
    height: 20px;
    opacity: 0.5;
  }
  50% {
    height: 40px;
    opacity: 1;
  }
}
.bounce-loader {
  display: flex;
  gap: 12px;
}

.bounce-circle {
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: var(--loader-color, #0d6efd);
  animation: bounce-circle 0.6s ease-in-out infinite alternate;
}

.bounce-circle:nth-child(1) {
  animation-delay: -0.32s;
}

.bounce-circle:nth-child(2) {
  animation-delay: -0.16s;
}

.bounce-circle:nth-child(3) {
  animation-delay: 0s;
}

@keyframes bounce-circle {
  0% {
    transform: translateY(0) scale(1);
  }
  100% {
    transform: translateY(-20px) scale(1.1);
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
@media (max-width: 576px) {
  .loader-lg {
    transform: scale(1.2);
  }
  .bars-loader .bar {
    width: 5px;
  }
  .dots-loader {
    gap: 6px;
  }
  .dot {
    width: 10px;
    height: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./src/app/shared/components/inline-spinner/inline-spinner.component.scss"],"names":[],"mappings":"AACA;EACE,kBAAA;EACA,MAAA;EACA,OAAA;EACA,QAAA;EACA,SAAA;EACA,oCAAA;EACA,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;EACA,aAAA;EACA,kBAAA;AAAF;;AAGA;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;EACA,mBAAA;AAAF;;AAGA;EACE,qBAAA;AAAF;;AAGA;EACE,mBAAA;EACA,gBAAA;EACA,8BAAA;AAAF;;AAIA;EACE,qBAAA;AADF;;AAIA;EACE,mBAAA;AADF;;AAIA;EACE,qBAAA;AADF;;AAKA;EAAiB,uBAAA;AADjB;;AAEA;EAAiB,uBAAA;AAEjB;;AADA;EAAc,uBAAA;AAKd;;AAJA;EAAiB,uBAAA;AAQjB;;AAPA;EAAgB,uBAAA;AAWhB;;AAVA;EAAe,uBAAA;AAcf;;AAbA;EAAc,uBAAA;AAiBd;;AAZA;EACE,qBAAA;EACA,kBAAA;EACA,WAAA;EACA,YAAA;AAeF;;AAZA;EACE,kBAAA;EACA,UAAA;EACA,WAAA;EACA,kBAAA;EACA,wCAAA;EACA,4CAAA;AAeF;;AAZA;EAA+C,MAAA;EAAQ,SAAA;EAAW,2BAAA;EAA6B,mBAAA;AAmB/F;;AAlBA;EAA+C,QAAA;EAAU,UAAA;EAAY,sBAAA;AAwBrE;;AAvBA;EAA+C,QAAA;EAAU,QAAA;EAAU,2BAAA;EAA6B,sBAAA;AA8BhG;;AA7BA;EAA+C,WAAA;EAAa,UAAA;EAAY,sBAAA;AAmCxE;;AAlCA;EAA+C,SAAA;EAAW,SAAA;EAAW,2BAAA;EAA6B,sBAAA;AAyClG;;AAxCA;EAA+C,WAAA;EAAa,SAAA;EAAW,sBAAA;AA8CvE;;AA7CA;EAA+C,QAAA;EAAU,OAAA;EAAS,2BAAA;EAA6B,sBAAA;AAoD/F;;AAnDA;EAA+C,QAAA;EAAU,SAAA;EAAW,sBAAA;AAyDpE;;AAvDA;EACE;IAAgB,UAAA;IAAY,qBAAA;EA4D5B;EA3DA;IAAM,UAAA;IAAY,mBAAA;EA+DlB;AACF;AA1DA;EACE,aAAA;EACA,QAAA;AA4DF;;AAzDA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,+CAAA;AA4DF;;AAzDA;EAAoB,uBAAA;AA6DpB;;AA5DA;EAAoB,uBAAA;AAgEpB;;AA/DA;EAAoB,mBAAA;AAmEpB;;AAlEA;EAAoB,sBAAA;AAsEpB;;AApEA;EACE;IACE,mBAAA;IACA,YAAA;EAuEF;EArEA;IACE,mBAAA;IACA,UAAA;EAuEF;AACF;AAjEA;EACE,kBAAA;EACA,WAAA;EACA,YAAA;AAmEF;;AAhEA;EACE,kBAAA;EACA,QAAA;EACA,SAAA;EACA,gCAAA;EACA,WAAA;EACA,YAAA;EACA,8CAAA;EACA,kBAAA;EACA,4CAAA;AAmEF;;AAhEA;EAA2B,mBAAA;AAoE3B;;AAnEA;EAA2B,sBAAA;AAuE3B;;AAtEA;EAA2B,oBAAA;AA0E3B;;AAxEA;EACE;IACE,2CAAA;IACA,UAAA;EA2EF;EAzEA;IACE,yCAAA;IACA,UAAA;EA2EF;AACF;AArEA;EACE,aAAA;EACA,QAAA;EACA,mBAAA;EACA,YAAA;AAuEF;;AApEA;EACE,UAAA;EACA,YAAA;EACA,wCAAA;EACA,kBAAA;EACA,6CAAA;AAuEF;;AApEA;EAAoB,sBAAA;AAwEpB;;AAvEA;EAAoB,oBAAA;AA2EpB;;AA1EA;EAAoB,sBAAA;AA8EpB;;AA7EA;EAAoB,sBAAA;AAiFpB;;AAhFA;EAAoB,sBAAA;AAoFpB;;AAlFA;EACE;IACE,YAAA;IACA,YAAA;EAqFF;EAnFA;IACE,YAAA;IACA,UAAA;EAqFF;AACF;AA/EA;EACE,aAAA;EACA,SAAA;AAiFF;;AA9EA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;EACA,wCAAA;EACA,4DAAA;AAiFF;;AA9EA;EAA8B,uBAAA;AAkF9B;;AAjFA;EAA8B,uBAAA;AAqF9B;;AApFA;EAA8B,mBAAA;AAwF9B;;AAtFA;EACE;IACE,iCAAA;EAyFF;EAvFA;IACE,uCAAA;EAyFF;AACF;AAnFA;EACE;IACE,UAAA;IACA,2BAAA;EAqFF;EAnFA;IACE,UAAA;IACA,wBAAA;EAqFF;AACF;AA/EA;EACE;IACE,qBAAA;EAiFF;EA9EA;IACE,UAAA;EAgFF;EA7EA;IACE,QAAA;EA+EF;EA5EA;IACE,WAAA;IACA,YAAA;EA8EF;AACF","sourcesContent":["// Container Styles\r\n.overlay-container {\r\n  position: absolute;\r\n  top: 0;\r\n  left: 0;\r\n  right: 0;\r\n  bottom: 0;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n  z-index: 1000;\r\n  border-radius: 8px;\r\n}\r\n\r\n.flex-center {\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: center;\r\n  align-items: center;\r\n}\r\n\r\n.loader-wrapper {\r\n  display: inline-block;\r\n}\r\n\r\n.loader-message {\r\n  font-size: 0.875rem;\r\n  font-weight: 500;\r\n  animation: fadeIn 0.3s ease-in;\r\n}\r\n\r\n// Size Variations\r\n.loader-sm {\r\n  transform: scale(0.6);\r\n}\r\n\r\n.loader-md {\r\n  transform: scale(1);\r\n}\r\n\r\n.loader-lg {\r\n  transform: scale(1.5);\r\n}\r\n\r\n// Theme Colors\r\n.theme-primary { --loader-color: #0d6efd; }\r\n.theme-success { --loader-color: #198754; }\r\n.theme-info { --loader-color: #0dcaf0; }\r\n.theme-warning { --loader-color: #ffc107; }\r\n.theme-danger { --loader-color: #dc3545; }\r\n.theme-light { --loader-color: #f8f9fa; }\r\n.theme-dark { --loader-color: #212529; }\r\n\r\n// ============================================\r\n// SPINNER STYLE (Default - Modern Circles)\r\n// ============================================\r\n.spinner-loader {\r\n  display: inline-block;\r\n  position: relative;\r\n  width: 50px;\r\n  height: 50px;\r\n}\r\n\r\n.spinner-loader .spinner-circle {\r\n  position: absolute;\r\n  width: 4px;\r\n  height: 4px;\r\n  border-radius: 50%;\r\n  background: var(--loader-color, #0d6efd);\r\n  animation: spinner-fade 1.2s linear infinite;\r\n}\r\n\r\n.spinner-loader .spinner-circle:nth-child(1) { top: 0; left: 50%; transform: translateX(-50%); animation-delay: 0s; }\r\n.spinner-loader .spinner-circle:nth-child(2) { top: 8px; right: 8px; animation-delay: -0.1s; }\r\n.spinner-loader .spinner-circle:nth-child(3) { top: 50%; right: 0; transform: translateY(-50%); animation-delay: -0.2s; }\r\n.spinner-loader .spinner-circle:nth-child(4) { bottom: 8px; right: 8px; animation-delay: -0.3s; }\r\n.spinner-loader .spinner-circle:nth-child(5) { bottom: 0; left: 50%; transform: translateX(-50%); animation-delay: -0.4s; }\r\n.spinner-loader .spinner-circle:nth-child(6) { bottom: 8px; left: 8px; animation-delay: -0.5s; }\r\n.spinner-loader .spinner-circle:nth-child(7) { top: 50%; left: 0; transform: translateY(-50%); animation-delay: -0.6s; }\r\n.spinner-loader .spinner-circle:nth-child(8) { top: 8px; left: 8px; animation-delay: -0.7s; }\r\n\r\n@keyframes spinner-fade {\r\n  0%, 39%, 100% { opacity: 0; transform: scale(0.3); }\r\n  40% { opacity: 1; transform: scale(1); }\r\n}\r\n\r\n// ============================================\r\n// DOTS STYLE (Modern Pulsing Dots)\r\n// ============================================\r\n.dots-loader {\r\n  display: flex;\r\n  gap: 8px;\r\n}\r\n\r\n.dot {\r\n  width: 12px;\r\n  height: 12px;\r\n  border-radius: 50%;\r\n  background: var(--loader-color, #0d6efd);\r\n  animation: dot-bounce 1.4s ease-in-out infinite;\r\n}\r\n\r\n.dot:nth-child(1) { animation-delay: -0.32s; }\r\n.dot:nth-child(2) { animation-delay: -0.16s; }\r\n.dot:nth-child(3) { animation-delay: 0s; }\r\n.dot:nth-child(4) { animation-delay: 0.16s; }\r\n\r\n@keyframes dot-bounce {\r\n  0%, 80%, 100% {\r\n    transform: scale(0);\r\n    opacity: 0.5;\r\n  }\r\n  40% {\r\n    transform: scale(1);\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n// ============================================\r\n// PULSE STYLE (Expanding Rings)\r\n// ============================================\r\n.pulse-loader {\r\n  position: relative;\r\n  width: 60px;\r\n  height: 60px;\r\n}\r\n\r\n.pulse-ring {\r\n  position: absolute;\r\n  top: 50%;\r\n  left: 50%;\r\n  transform: translate(-50%, -50%);\r\n  width: 100%;\r\n  height: 100%;\r\n  border: 3px solid var(--loader-color, #0d6efd);\r\n  border-radius: 50%;\r\n  animation: pulse-ring 1.5s ease-out infinite;\r\n}\r\n\r\n.pulse-ring:nth-child(1) { animation-delay: 0s; }\r\n.pulse-ring:nth-child(2) { animation-delay: -0.5s; }\r\n.pulse-ring:nth-child(3) { animation-delay: -1s; }\r\n\r\n@keyframes pulse-ring {\r\n  0% {\r\n    transform: translate(-50%, -50%) scale(0.1);\r\n    opacity: 1;\r\n  }\r\n  100% {\r\n    transform: translate(-50%, -50%) scale(1);\r\n    opacity: 0;\r\n  }\r\n}\r\n\r\n// ============================================\r\n// BARS STYLE (Wave Animation)\r\n// ============================================\r\n.bars-loader {\r\n  display: flex;\r\n  gap: 4px;\r\n  align-items: center;\r\n  height: 40px;\r\n}\r\n\r\n.bar {\r\n  width: 6px;\r\n  height: 20px;\r\n  background: var(--loader-color, #0d6efd);\r\n  border-radius: 3px;\r\n  animation: bar-wave 1.2s ease-in-out infinite;\r\n}\r\n\r\n.bar:nth-child(1) { animation-delay: -1.1s; }\r\n.bar:nth-child(2) { animation-delay: -1.0s; }\r\n.bar:nth-child(3) { animation-delay: -0.9s; }\r\n.bar:nth-child(4) { animation-delay: -0.8s; }\r\n.bar:nth-child(5) { animation-delay: -0.7s; }\r\n\r\n@keyframes bar-wave {\r\n  0%, 100% {\r\n    height: 20px;\r\n    opacity: 0.5;\r\n  }\r\n  50% {\r\n    height: 40px;\r\n    opacity: 1;\r\n  }\r\n}\r\n\r\n// ============================================\r\n// BOUNCE STYLE (Bouncing Circles)\r\n// ============================================\r\n.bounce-loader {\r\n  display: flex;\r\n  gap: 12px;\r\n}\r\n\r\n.bounce-circle {\r\n  width: 18px;\r\n  height: 18px;\r\n  border-radius: 50%;\r\n  background: var(--loader-color, #0d6efd);\r\n  animation: bounce-circle 0.6s ease-in-out infinite alternate;\r\n}\r\n\r\n.bounce-circle:nth-child(1) { animation-delay: -0.32s; }\r\n.bounce-circle:nth-child(2) { animation-delay: -0.16s; }\r\n.bounce-circle:nth-child(3) { animation-delay: 0s; }\r\n\r\n@keyframes bounce-circle {\r\n  0% {\r\n    transform: translateY(0) scale(1);\r\n  }\r\n  100% {\r\n    transform: translateY(-20px) scale(1.1);\r\n  }\r\n}\r\n\r\n// ============================================\r\n// Fade In Animation for Message\r\n// ============================================\r\n@keyframes fadeIn {\r\n  from {\r\n    opacity: 0;\r\n    transform: translateY(10px);\r\n  }\r\n  to {\r\n    opacity: 1;\r\n    transform: translateY(0);\r\n  }\r\n}\r\n\r\n// ============================================\r\n// Responsive Adjustments\r\n// ============================================\r\n@media (max-width: 576px) {\r\n  .loader-lg {\r\n    transform: scale(1.2);\r\n  }\r\n\r\n  .bars-loader .bar {\r\n    width: 5px;\r\n  }\r\n\r\n  .dots-loader {\r\n    gap: 6px;\r\n  }\r\n\r\n  .dot {\r\n    width: 10px;\r\n    height: 10px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
